import React from 'react';
import { graphql } from 'react-apollo';
import MUIDataTable from "mui-datatables";

import { Grid } from '@material-ui/core';

import { GET_BLACK_LIST } from "../../../queries/blackList";
import DeleteblackList from "./delete";

// components
import DrawerPlacements from '../../../components/DrawerPlacements';
import PageError from '../../../components/PageError';
import PageLoading from '../../../components/PageLoading';
import PageTitle from "../../../components/PageTitle/PageTitle";
import AddBlackListURLs from '../../../pages/blackList/actions/create';
import UpdateBlackListURLs from '../../../pages/blackList/actions/edit';

const blackList = ({ data: { blackList, loading, error }}) => {

  const options = {
    selectableRows: 'checkbox',
    responsive: "scrollMaxHeight",
    customToolbarSelect: selectedRows => (
      <DeleteblackList selectedRows = {selectedRows} blackLists={blackList}/>
    )
  };

  const ActionsRow = (tableMeta) => {
    var id = tableMeta.rowData[1];
    var url = tableMeta.rowData[2];
    var reason = tableMeta.rowData[3];
    return (
      <>
      <DrawerPlacements title="Edit Black List" iconButtonAction={false} labeButtonAction={url}>
        <UpdateBlackListURLs id = {id} url = {url} reason = {reason}></UpdateBlackListURLs>
      </DrawerPlacements>
      </>
    );
  };

  return (
    <>
      <Grid container spacing={0}>
        <Grid item xs={10}>
          <PageTitle title="Black List"/>
        </Grid>
        <Grid item xs={2}>
          <DrawerPlacements title="Black List" labeButtonAction="Add">
            <AddBlackListURLs></AddBlackListURLs>
          </DrawerPlacements>

        </Grid>
      </Grid>
      
      {
        (loading) ? <PageLoading /> : 
        (error) ? <PageError /> :
        (
          <Grid container spacing={4}>
            <Grid item xs={12}>
              <MUIDataTable
                title={false}
                data={blackList}
                columns={[
                  {
                    name    : 'url',
                    options : {
                      customBodyRender: (value, tableMeta, updateValue) => { 
                        return (ActionsRow(tableMeta))
                      },
                      empty  : true,
                      filter : true,
                      sort   : true,                     
                    }
                  },{
                    name    : 'id',
                    options : {
                      display : false
                    }
                  },{
                    name    : 'url',
                    options : {
                      display : false
                    }
                  },
                  'reason'
                ]}
                options={options}
              />
            </Grid>
          </Grid>
        )
      }
  </>);
}

export const BlackListURLs = graphql(GET_BLACK_LIST)((blackList));